import React from 'react'
import Factory from '@leverege/factory'

const ViewerFactory = new Factory( {
  strategy : Factory.reactStrategy( React )
} )

export default ViewerFactory
